import { render, staticRenderFns } from "./RoomSection.vue?vue&type=template&id=155711f0&scoped=true&"
import script from "./RoomSection.vue?vue&type=script&lang=js&"
export * from "./RoomSection.vue?vue&type=script&lang=js&"
import style0 from "./RoomSection.vue?vue&type=style&index=0&id=155711f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155711f0",
  null
  
)

export default component.exports